import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';
import { direction } from '../../styles/tokens';

const SOLID_THRESHOLD_PCT = 2;

interface PriceChangeProps {
  value: number; // percent
  showIcon?: boolean;
  className?: string;
}

const PriceChange: React.FC<PriceChangeProps> = ({ value, showIcon = true, className = '' }) => {
  // Zero is not a gain: rendering "+0.00%" in green with an up-arrow (the
  // old behavior) reads as a price increase when nothing moved. Shares
  // `direction` with the chart series so the two can never disagree.
  const d = direction(value);
  const flat = d === 'flat';
  const up = d === 'up';
  const solid = Math.abs(value) >= SOLID_THRESHOLD_PCT;
  const chipClass = flat
    ? 'chip-neutral'
    : `${up ? 'chip-up' : 'chip-down'}${solid ? '-solid' : ''}`;
  const Icon = flat ? Minus : up ? TrendingUp : TrendingDown;
  return (
    <span className={`chip ${chipClass} ${className}`}>
      {showIcon && <Icon className="w-3 h-3" />}
      {up ? '+' : ''}{value.toFixed(2)}%
    </span>
  );
};

export default PriceChange;
